import { render, staticRenderFns } from "./SellerDetailsStep5.vue?vue&type=template&id=8e7347b6&scoped=true"
import script from "./SellerDetailsStep5.vue?vue&type=script&lang=js"
export * from "./SellerDetailsStep5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7347b6",
  null
  
)

export default component.exports